module.exports = __webpack_public_path__ + "img/equipos-moviles-img-9.4c3a5072.jpg";